import { ReactComponent as CheckMark } from '../assets/icons/checkmark-stroke.svg'
export default function Slide({
  url,
  pageNum,
  id,
  selectedSlide,
  selectedMode,
  currentPage,
  dragMode,
  studentData,
  isSmall,
}) {
  return (
    <div
      // className='box-border h-[178px] w-[314px] overflow-hidden rounded-10 bg-center bg-no-repeat'
      className={`relative box-border h-full w-full overflow-hidden bg-cover bg-no-repeat ${isSmall ? 'rounded-4 bg-left-top' : 'tab:rounded-8 board:rounded-10 rounded-6 bg-center'} ${dragMode ? (selectedSlide?.includes(id) ? 'border-label-disable' : 'board:border-2 border border-solid border-border-strong') : selectedMode ? (selectedSlide?.includes(id) ? 'board:border-4 border-2 border-solid border-border-active' : 'board:border-2 border border-solid border-border-strong') : currentPage === pageNum ? 'board:border-4 border-2 border-solid border-border-active' : 'board:border-2 border border-solid border-border-strong'} ${url ? '' : 'bg-background-default'} `}
      style={{ backgroundImage: `url(${url})` }}
    >
      <div
        className={`relative h-full w-full ${dragMode && selectedSlide?.includes(id) ? 'bg-label-disable' : ''} ${selectedSlide?.includes(id) ? 'bg-dimmer-primary' : 'bg-transparent hover:bg-dimmer-sub'}`}
      >
        {dragMode && selectedSlide?.includes(id) ? null : studentData ? (
          <div className='flex w-max overflow-hidden rounded-br-4 shadow-pageNo'>
            <p
              className={`tab:text-body1-semibold tab:px-10 px-8 py-4 text-caption-semibold ${studentData.isActive ? (currentPage === pageNum ? 'bg-border-active text-static-white' : 'bg-background-secondary text-primary-normal') : currentPage === pageNum ? 'bg-border-active text-static-white' : 'bg-label-info text-static-white'}`}
            >
              {pageNum}
            </p>
            <p
              className={`board:px-8 text-caption2-semibold tab:text-body2-long-semibold px-6 pb-4 pt-6 text-static-white ${studentData.isActive ? 'bg-primary-normal' : 'bg-label-placeholder'}`}
            >
              {studentData.name}
            </p>
          </div>
        ) : (
          <p
            className={`tab:text-body1-semibold w-min rounded-br-4 text-caption-semibold shadow-pageNo 3xl:px-12 3xl:text-h1-semibold ${isSmall ? 'px-6 py-2' : 'tab:px-10 px-8 py-4'} ${selectedMode ? (selectedSlide?.includes(id) ? 'bg-border-active text-static-white' : 'bg-background-secondary text-primary-normal') : currentPage === pageNum ? 'bg-border-active text-static-white' : 'bg-background-secondary text-primary-normal'}`}
          >
            {pageNum}
          </p>
        )}
      </div>
      {!dragMode && selectedSlide?.includes(id) && (
        <div
          className={`absolute ${isSmall ? 'board:bottom-4 board:right-4 bottom-6 right-6' : 'bottom-8 right-8 3xl:bottom-12 3xl:right-12'}`}
        >
          <CheckMark
            className={`${isSmall ? 'board:h-24 board:w-24 h-20 w-20' : 'tab:h-32 tab:w-32 h-20 w-20 3xl:h-[44px] 3xl:w-[44px]'}`}
          />
        </div>
      )}
    </div>
  )
}
